// eslint-disable-next-line max-classes-per-file
export interface FlightSeatsInterface {
  keyDeparture?: string | undefined;
  keyReturn?: string | undefined;
  keySearch: string;
  keySearchDatetime: number;
  [key: string]: string | number | undefined;
}
export interface FlightSeatsBaseResponse {
  status: boolean;
  data: SeatMap[];
  message: any;
}

export interface SeatmapCabinFacilities {
  seatRow: number;
  type: FacilitiesNum;
  location: string;
  object: string;
}

export interface SeatMapDetail {
  seatMapLeg: string;
  departureAirport: string;
  arrivalAirport: string;
  departureAirportCityName: string;
  arrivalAirportCityName: string;
  departureDateTime: string;
  arrivalDateTime: string;
  marketingAirline: string;
  flightNumber: string;
  equipment: string;
  seats: Seat[];
  cabinFacilities?: any;
}

export class SeatMap {
  seatMapDetail: SeatMapDetail;

  constructor(data: any) {
    this.seatMapDetail = data.seatMapDetail;
  }
}

export class Departure {
  searchPriceId: number;

  supplierName: number;

  constructor(data: any) {
    this.searchPriceId = data?.searchPriceId || 0;
    this.supplierName = data?.supplierName || 0;
  }
}

export class Legs {
  departure: Departure[];

  return: Departure[];

  constructor(data: any) {
    this.departure =
      data && data.departure?.length
        ? data.departure?.map((Object: Departure) => new Departure(Object))
        : new Departure({});
    this.return =
      data && data.return?.length
        ? data.return?.map((Object: Departure) => new Departure(Object))
        : new Departure({});
  }
}

export interface Properties {
  window: string;
  aisle: string;
  wing: string;
  exitrow: string;
  bulkhead: string;
}

export class PropertiesRespone {
  window: string = "";

  aisle: string = "";

  wing: string = "";

  exitrow: string = "";

  bulkhead: string = "";

  constructor(data: any) {
    this.window = data?.window || "";
    this.aisle = data?.aisle || "";
    this.wing = data?.wing || "";
    this.exitrow = data?.exitrow || "";
    this.bulkhead = data?.bulkhead || "";
  }
}

export interface Price {
  currency: string;
  amount: number;
}

export class PriceRespone {
  currency: string = "";

  amount: number = 0;

  constructor(data: any) {
    this.currency = data?.currency || "";
    this.amount = data?.amount || 0;
  }
}

export enum FacilitiesNum {
  galley = "galley",
  lavatory = "lavatory",
}

export interface Seat {
  seatRow: string;
  seatColumn: string;
  seatNumber: string;
  assignable: string;
  availability: string;
  properties: Properties;
  price: Price;
  seatKey: string;
  passengersNo?: number;
  [key: string]: any;
}

export class SeatClass {
  seatRow: string;

  seatColumn: string;

  seatNumber: string;

  assignable: string;

  availability: string;

  properties: Properties[];

  price: Price[];

  seatKey: string;

  passengersNo?: number;

  [key: string]: any;

  constructor(data: any) {
    this.seatRow = data?.seatRow || "";
    this.seatColumn = data?.seatColumn || "";
    this.seatNumber = data?.seatNumber || "";
    this.assignable = data?.assignable || "";
    this.availability = data?.availability || "";
    this.properties = data?.properties || "";
    this.price = data?.price || "";
    this.seatKey = data?.seatKey || "";
    this.passengersNo = data?.passengersNo || 0;
  }
}

export class SeatRespone {
  seatRow: string = "";

  seatColumn: string = "";

  seatNumber: string = "";

  assignable: string = "";

  availability: string = "";

  properties: PropertiesRespone[];

  price: PriceRespone[];

  seatKey: string = "";

  passengersNo?: number = 0;

  cabinFacilities?: SeatmapCabinFacilities;

  props?: { [key: string]: any };

  constructor(data: any) {
    this.seatRow = data?.seatRow || "";
    this.seatColumn = data?.seatColumn || "";
    this.seatNumber = data?.seatNumber || "";
    this.assignable = data?.assignable || "";
    this.availability = data?.availability || "";
    this.cabinFacilities = data.cabinFacilities;
    this.properties =
      data && data.properties?.length
        ? data.properties?.map(
            (Object: PropertiesRespone) => new PropertiesRespone(Object),
          )
        : new PropertiesRespone({});
    this.price =
      data && data.price?.length
        ? data.price?.map((Object: PriceRespone) => new PriceRespone(Object))
        : new PriceRespone({});
    this.passengersNo = data?.passengersNo || 0;

    if (this.props) {
      Object.assign(this, data?.props || []);
    }
  }
}

export interface FlightAllocateParamsInterface {
  passengers: any;
  keyDeparture?: string | undefined;
  keyReturn?: string | undefined;
  keySearch: string;
  keySearchDatetime: number;
  "legs[departure][searchPriceId]": number;
  "legs[departure][supplierName]": string;
  "legs[return][searchPriceId]"?: number | undefined | string;
  "legs[return][supplierName]"?: string;

  "contact[title]": string;
  "contact[firstName]": string;
  "contact[middleName]"?: string;
  "contact[lastName]": string;
  "contact[callingCodes]": string;
  "contact[mobilePhone]": number | string;
  "contact[email]": string;
  preferredCurrency: string;
  endUserIPAddress?: string;
  endUserBrowserAgent?: string;
  agentUserId?: number;
  seatSelectKey?: string;
  url_callback_unsuccess: string;
  [key: string]: number | string | undefined | any;
  itemListName?: string;
  is_addons_status: 0 | 1;
  couponCode?: string;
  _fbp?: string;
  _fbc?: string;
  ttclid?: string;
  _ttp?: string;
}

export class FlightAllocateParamsRespone {
  passengers: any = null;

  keyDeparture?: string | undefined = "";

  keyReturn?: string | undefined = "";

  keySearch: string = "";

  keySearchDatetime: number = 0;

  preferredCurrency: string = "";

  endUserIPAddress?: string = "";

  endUserBrowserAgent?: string = "";

  agentUserId?: number = 0;

  seatSelectKey?: string = "";

  url_callback_unsuccess: string = "";

  itemListName?: string = "";

  is_addons_status: number = 0;

  couponCode?: string = "";

  legs: Legs[];

  contact: {
    title: string;
    firstName: string;
    middleName: string;
    lastName: string;
    callingCodes: string;
    mobilePhone: string;
    email: string;
  };

  props?: { [key: string]: number | string | undefined | any };

  constructor(data: any) {
    this.passengers = data?.passenger || null;
    this.keyDeparture = data?.keyDeparture || "";
    this.keyReturn = data?.keyReturn || "";
    this.keySearch = data?.keySearch || "";
    this.keySearchDatetime = data?.keySearchDatetime || 0;
    this.preferredCurrency = data?.preferredCurrency || "";
    this.endUserIPAddress = data?.endUserIPAddress || "";
    this.endUserBrowserAgent = data?.endUserBrowserAgent || "";
    this.agentUserId = data?.agentUserId || 0;
    this.seatSelectKey = data?.seatSelectKey || "";
    this.url_callback_unsuccess = data?.url_callback_unsuccess || "";
    this.itemListName = data?.itemListName || "";
    this.is_addons_status = data?.is_addons_status || "";
    this.couponCode = data?.couponCode || "";
    this.legs =
      data && data.legs?.length
        ? data.legs?.map((Object: Legs) => new Legs(Object))
        : new Legs({});
    this.contact = {
      title: data.title || "",
      firstName: data.firstName || "",
      middleName: data.middleName || "",
      lastName: data.lastName || "",
      callingCodes: data.callingCodes || "",
      mobilePhone: data?.mobilePhone || "",
      email: data.email || "",
    };

    if (this.props) {
      Object.assign(this, data?.props);
    }
  }
}

export interface Passenger {
  title?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  dob?: string;
  nationality?: string;
  passengerType?: string;
  checkInType?: string;
  baggages?: {
    departure?: {
      baggageKey?: string;
    };
    return?: {
      baggageKey?: string;
    };
  };
  baggageTracking?: number;
  meals?: {
    departure?: {
      [index: number]: {
        mealKey?: string;
      };
    };
    return?: {
      [index: number]: {
        mealKey?: string;
      };
    };
  };
  insurance?: {
    cardType?: string;
    cardNo?: number;
    cardExpired?: string;
  };
  airlineMembers?: {
    [index: number]: {
      alliance?: string;
      memberNumber?: string;
    };
  };
}

export class PassengerRespone {
  title?: string = "";

  firstName?: string = "";

  middleName?: string = "";

  lastName?: string = "";

  dob?: string = "";

  nationality?: string = "";

  passengerType?: string = "";

  checkInType?: string = "";

  baggages?: {
    departure?: {
      baggageKey?: string;
    };
    return?: {
      baggageKey?: string;
    };
  };

  baggageTracking?: number = 0;

  meals?: {
    departure?: {
      [index: number]: {
        mealKey?: string;
      };
    };
    return?: {
      [index: number]: {
        mealKey?: string;
      };
    };
  };

  insurance?: {
    cardType?: string;
    cardNo?: number;
    cardExpired?: string;
  };

  airlineMembers?: {
    [index: number]: {
      alliance?: string;
      memberNumber?: string;
    };
  };

  constructor(data: any) {
    this.title = data?.title || "";
    this.firstName = data?.firstName || "";
    this.middleName = data?.middleName || "";
    this.lastName = data?.lastName || "";
    this.dob = data?.dob || "";
    this.nationality = data?.nationality || "";
    this.passengerType = data?.passengerType || "";
    this.checkInType = data?.checkInType || "";
    this.baggages = {
      departure: {
        baggageKey: data?.baggageKey || "",
      },
      return: {
        baggageKey: data?.baggageKey || "",
      },
    };
    this.baggageTracking = data.baggageTracking || "";
    this.meals = {
      departure:
        data && data.mealKey?.length
          ? data.mealKey.reduce(
              (
                acc: { [index: number]: { mealKey?: string } },
                meal: { mealKey?: string },
                index: number,
              ) => {
                acc[index] = { mealKey: meal.mealKey };
                return acc;
              },
              {} as { [index: number]: { mealKey?: string } },
            )
          : "",
      return:
        data && data.mealKey?.length
          ? data.mealKey.reduce(
              (
                acc: { [index: number]: { mealKey?: string } },
                meal: { mealKey?: string },
                index: number,
              ) => {
                acc[index] = { mealKey: meal.mealKey };
                return acc;
              },
              {} as { [index: number]: { mealKey?: string } },
            )
          : "",
    };
    this.insurance = {
      cardType: data?.cardType || "",
      cardNo: data?.cardNo || "",
      cardExpired: data?.cardExpired || "",
    };
    this.airlineMembers =
      data && data.airlineMembers?.length
        ? data.airlineMembers.reduce(
            (
              acc: {
                [index: number]: { alliance?: string; memberNumber?: string };
              },
              member: { alliance?: string; memberNumber?: string },
              index: number,
            ) => {
              acc[index] = {
                alliance: member.alliance,
                memberNumber: member.memberNumber,
              };
              return acc;
            },
            {},
          )
        : null;
  }
}

export class ResponseSeatMap {
  data: SeatMap[];

  message: string | number;

  status: boolean;

  constructor(data: any) {
    this.data =
      data && data.data?.length
        ? data.data?.map((baggage: SeatMap) => new SeatMap(baggage))
        : new SeatMap({});
    this.message = data.message || "";
    this.status = data.status || false;
  }
}
